import {
  Edit,
  ListButton,
  required,
  SaveButton,
  ShowButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ShowButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <ShowButton />
  </TopToolbar>
);

export const CountryEdit = () => (
  <Edit actions={<EditActions />} mutationMode="pessimistic">
    <SimpleForm toolbar={<EditToolbar />}>
      <TextInput source="code" validate={required()} />
      <TextInput source="name" validate={required()} />
      <TextInput source="heartbeatName" validate={required()} />
    </SimpleForm>
  </Edit>
);
